import type { FC } from "react";

import { EducationContainer } from "app/components/educationbar/educationContainer";
import educationHook from "app/components/educationbar/educationHook";
import { NoPrintContainer } from "app/components/layout/NoPrintContainer";
import PageTitle from "app/components/React/PageTitle/PageTitle";
import { IndustryAnalysisQueryBar } from "app/pages/industry-analysis/industry-analysis-query-bar";

import IndustryAnalysisFilters from "../../pages/industry-analysis/IndustryAnalysisFilters";

import { SubNav } from "./SubNav";

export const IndustryAnalysisSubNav: FC = () => {
    const [showEducationIcon, showEducationBar, setValues] = educationHook();

    const onCloseEducationBar = () => {
        setValues(true, false);
    };

    const onEducationIconClick = () => {
        setValues(false, true);
    };

    return (
        <NoPrintContainer>
            <SubNav
                topLeftComponent={<IndustryAnalysisQueryBar />}
                bottomRightComponent={<IndustryAnalysisFilters />}
                bottomLeftComponent={
                    <PageTitle
                        showEducationIcon={showEducationIcon}
                        onEducationIconClick={onEducationIconClick}
                    />
                }
                education={
                    showEducationBar ? <EducationContainer onCloseEducationComponent={onCloseEducationBar} /> : null
                }
            />
        </NoPrintContainer>
    );
};
